import { getFirstCharName } from '../utils';

export const getPassengerAbbreviation = (name: string): string => {
	const [lastName, firstName] = name.split(' ');

	return getFirstCharName({ lastName, firstName });
};
